import InstallationDetails from './InstallationDetails';

export default InstallationDetails;
